<template lang="pug">
.rut-search-row
  .rut-input-wrapper
    b-icon.rut-search-icon(icon="search" font-scale="1")
    vue-typeahead-bootstrap.rut-typeahead(
      v-model="model"
      :data="data"
      :serializer="serializer"
      placeholder="Buscar cliente por RUT ej: 12345678-9"
      @input="$emit('rut-typed')"
      @hit="(item) => $emit('rut-selected', item)"
      :disabled="ov_id ? true : false"
      id="rut-component-autocomplete"
    )
  button.samtek-btn-secondary(
    type="button"
    v-if="showCreateBtn"
    @click="$emit('create-customer')"
  ) Crear Nuevo Cliente
</template>

<!-- TODO:  traer más lógica desde el clientform en lugar
            de pasar para arriba los eventos -->

<script>
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap'
// vue-typeahead-bootstrap-custom-eleva

export default {
  components: {
    VueTypeaheadBootstrap,
  },
  props: {
    data: Array,
    value: String,
    showCreateBtn: Boolean,
    ov_id: Number,
  },
  data: () => ({}),
  computed: {
    model: {
      get() {
        return this.value?.replace(/\./g, '')
      },
      set(v) {
        this.$emit('input', v)
        // Validacion de campo RUT (En caso de volver a solicitarse )
        // const rutLimpio = v.replace(/[^0-9kK]/g, '');
        // if (rutLimpio.length < 2) return rutLimpio;
        // this.$emit('input', rutLimpio)

      },
    },
  },
  methods: {
    serializer: (cliente) => {
      if (cliente.tipo_cliente === 'Persona' && cliente.persona) {
        return `${cliente.persona.rut}  /  ${cliente.persona.nombre}`
      }
      if (cliente.tipo_cliente === 'Empresa' && cliente.empresa) {
        return `${cliente.empresa.rut}  /  ${cliente.empresa.razon_social}`
      }
      return 'AAA'
    }
  },
}
</script>

<style lang="scss" scoped>
.rut-search-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.rut-input-wrapper {
  position: relative;
  flex: 1;
  min-width: 240px;
  max-width: 480px;

  .rut-search-icon {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: #525252;
    z-index: 10;
    pointer-events: none;
  }

  .rut-typeahead {
    ::v-deep input {
      padding-left: 34px !important;
      border: 1px solid #525252;
      border-radius: 5px;
      background-color: #fff;
      font-family: 'Noto Sans', sans-serif;
      font-size: 15px;
      color: #525252;
      height: 40px;

      &::placeholder { color: #525252; }
      &:focus { border-color: #FECE2F; outline: none; box-shadow: 0 0 0 2px rgba(254,206,47,0.25); }
    }
  }
}

.samtek-btn-secondary {
  height: 45px;
  padding: 10px 20px;
  background-color: #F5F6FA;
  color: #23201C;
  border: 1px solid #525252;
  border-radius: 8px;
  font-family: 'Noto Sans', sans-serif;
  font-weight: 500;
  font-size: 15px;
  cursor: pointer;
  white-space: nowrap;
  transition: background-color 0.15s;

  &:hover { background-color: #e8e9ef; }
}
</style>
